const cart = {
  title: 'italist | Contest',
  description: 'Win TWO limited-edition The North Face x Gucci jackets ($4,000 value and sold out globally!)',
  overrideImages: ['https://i.ibb.co/JxwPkDF/gucci-northface-jackets-contest-1000px.png'],
};

export default cart;
